<template>
    <app-view @open="onOpen" @restore="onRestore">
        <div class="list">
            <div class="item" v-for="(item, i) in list" :key="i">
                <router-link class="poster" :style="item.thumb | bg" :to="'/lives/' + item.id">
                    <div class="mask">
                        <div class="live orange" v-if="item.push_status == 0">待直播</div>
                        <div class="live red" v-if="item.push_status == 1">直播中</div>
                        <div class="live gray" v-if="item.push_status == 2">已结束</div>
                        <div class="live blue" v-if="item.push_status == 3">回放</div>
                        <div class="name">
                            <div>{{ item.title }}</div>
                            <div class="time">开播：{{ item.starttime | datetime2 }}</div>
                        </div>
                    </div>
                </router-link>
                <div class="info">
                    <span>
                        <i class="icon icon-zongrenshu"></i>
                        <span>{{ item.online | unit }}</span>
                    </span>
                    <span>
                        <i class="icon icon-guankancishu"></i>
                        <span>{{ item.hits | unit }}</span>
                    </span>
                    <span class="space"></span>
                    <a :class="{ on: item.good }" @click="onVote(item)">
                        <i class="icon icon-a-lujing133"></i>
                        <span v-if="item.good">{{ item.agree | unit }}</span>
                        <span v-else>点赞</span>
                    </a>
                    <a v-if="item.donate_url" @click="onShowSupport(item)">
                        <i class="icon icon-a-Iconawesome-donate"></i>
                        <span>参与</span>
                    </a>
                    <a v-if="canShare && item.share_status > 0" @click="onShowShare(item)">
                        <i class="icon icon-share"></i>分享
                    </a>
                </div>
            </div>
        </div>
    </app-view>
</template>
<script>
import app from '../../app'
import AppView from '../components/AppView.vue'
export default {
    components: { AppView, },
    filters: {
        bg(url) {
            return {
                backgroundImage: 'url(' + url + ')'
            }
        }
    },
    data() {
        return {
            list: []
        }
    },
    computed: {
        canShare() {
            return window.inApp
        }
    },
    methods: {
        onShowShare(item) {
            let url = 'https://mfuyin.tv/index.html?#/lives/' + item.id
            if (item.share_url) {
                url = item.share_url
            }
            app.callShare(item.title, '一起看-福音影视网 iFUYIN.COM', item.thumb, url)
        },
        onShowSupport(item) {
            if (window.inApp) {
                app.openView(item.donate_url, item.donate_target == 1, true)
            } else {
                window.location.href = item.donate_url
            }
        },
        async onOpen() {
            let { list } = await this.$service.lives.loadList()
            let map = {}
            let goods = localStorage.getItem('live-goods')
            if (goods) {
                try {
                    map = JSON.parse(goods)
                } catch (e) {
                }
            }
            for (let item of list) {
                item.good = !!map[item.id]
            }
            this.list = list
        },
        onRestore() {
            this.onOpen()
        },
        async onVote(item) {
            if (item.good) {
                return
            }
            await this.$service.lives.postVote(item.id)
            item.good = true
            item.agree++
            let map = {}
            for (let item of this.list) {
                if (item.good) {
                    map[item.id] = 1
                }
            }
            localStorage.setItem('live-goods', JSON.stringify(map))
        }
    }
}
</script>
<style scoped lang="scss">
.item {
    margin-bottom: 10px;

    .poster {
        display: block;
        position: relative;
        height: rem(421);
        background-size: cover;
        background-position: center center;

        .mask {
            position: relative;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
        }

        .live {
            position: absolute;
            left: 6px;
            top: 6px;
            font-size: 12px;
            font-weight: bold;
            padding: 0 4px;
            border-radius: 2px;

            &.red {
                color: white;
                background-color: #f05f5f;
            }

            &.orange {
                color: white;
                background-color: orange;
            }

            &.blue {
                color: white;
                background-color: rgb(6, 118, 255);
            }

            &.gray {
                color: #666;
                background-color: #ccc;
            }
        }

        .name {
            position: absolute;
            width: 100%;
            padding: 0 6px 6px;
            left: 0;
            bottom: 0;
            color: white;
            font-size: 18px;
            font-weight: bold;

            .time {
                font-size: 14px;
            }
        }
    }

    .info {
        display: flex;
        align-items: center;
        height: rem(100);
        padding: 0 6px;
        font-size: 14px;
        background-color: white;

        .space {
            flex: 1;
        }

        >span {
            &+span {
                margin-left: 14px;
            }
        }

        a {
            margin-left: 14px;
            color: #666;

            &.on {
                color: #f05f5f;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?0ef26cec